// src/redux/actions/dashboardActions.js
export const SET_ACTIVE_SECTION = "SET_ACTIVE_SECTION";
export const SET_ACTIVE_TAB_PROJET = "SET_ACTIVE_TAB_PROJET";
export const SET_ACTIVE_TAB_MATCH = "SET_ACTIVE_TAB_MATCH";
export const SET_ACTIVE_TAB_PROPOSITION_SELECTED = "SET_ACTIVE_TAB_PROPOSITION_SELECTED";
export const SET_ACTIVE_TAB_APPEL_OFFRE = "SET_ACTIVE_TAB_APPEL_OFFRE";
export const SET_ACTIVE_TAB_MATCH_APPEL_OFFRE = "SET_ACTIVE_TAB_MATCH_APPEL_OFFRE";
export const SET_ACTIVE_PROJET = "SET_ACTIVE_PROJET";
export const SET_ACTIVE_APPEL_OFFRE = "SET_ACTIVE_APPEL_OFFRE";
export const OPEN_MESSAGES_WITH_MATCH = "OPEN_MESSAGES_WITH_MATCH";
export const RESET_DASHBOARD = "RESET_DASHBOARD";
export const SET_ACTIVE_PRESTATAIRE = "SET_ACTIVE_PRESTATAIRE";
export const SET_ACTIVE_ADMIN = "SET_ACTIVE_ADMIN";
export const SET_ACTIVE_CLIENT = "SET_ACTIVE_CLIENT";
export const SET_ACTIVE_ROLE = "SET_ACTIVE_ROLE";
export const SET_ACTIVE_DONNEUR_ORDRE = "SET_ACTIVE_DONNEUR_ORDRE";
export const SET_ACTIVE_USER = "SET_ACTIVE_USER";
export const SET_ACTIVE_USER_TAB = "SET_ACTIVE_USER_TAB";


export const setActivePrestataire = (prestataire) => ({
  type: SET_ACTIVE_PRESTATAIRE,
  payload: prestataire,
});

export const setActiveAdmin = (admin) => ({
  type: SET_ACTIVE_ADMIN,
  payload: admin,
});

export const setActiveClient = (client) => ({
  type: SET_ACTIVE_CLIENT,
  payload: client,
});

export const setActiveDonneurOrdre = (donneurOrdre) => ({
  type: SET_ACTIVE_DONNEUR_ORDRE,
  payload: donneurOrdre,
});

export const setActiveUser = (user) => ({
  type: SET_ACTIVE_USER,
  payload: user,
});

export const setActiveUserTab = (userTab) => ({
  type: SET_ACTIVE_USER_TAB,
  payload: userTab,
});

export const setActiveRole = (role) => ({
  type: SET_ACTIVE_ROLE,
  payload: role,
});

export const setActiveSection = (section) => ({
  type: SET_ACTIVE_SECTION,
  payload: section,
});

export const setActiveTabProjet = (tabProjet) => ({
  type: SET_ACTIVE_TAB_PROJET,
  payload: tabProjet,
});

export const setActiveTabMatch = (tabMatch) => ({
  type: SET_ACTIVE_TAB_MATCH,
  payload: tabMatch,
});

export const setActiveTabPropositionSelected = (tabPropositionSelected) => ({
  type: SET_ACTIVE_TAB_PROPOSITION_SELECTED,
  payload: tabPropositionSelected,
});

export const setActiveTabMatchAppelOffre = (tabMatchAppelOffre) => ({
  type: SET_ACTIVE_TAB_MATCH_APPEL_OFFRE,
  payload: tabMatchAppelOffre,
});

export const setActiveTabAppelOffre = (tabAppelOffre) => ({
  type: SET_ACTIVE_TAB_APPEL_OFFRE,
  payload: tabAppelOffre,
});

export const setActiveProjet = (projet) => ({
  type: SET_ACTIVE_PROJET,
  payload: projet,
});

export const setActiveAppelOffre = (appelOffre) => ({
  type: SET_ACTIVE_APPEL_OFFRE,
  payload: appelOffre,
});

export const resetDashboard = () => ({
  type: RESET_DASHBOARD,
});
